import React, { useState, useEffect } from 'react';
import filterIconEmpty from '../../../assets/icons/filter-empty.svg';
import filterIconFull from '../../../assets/icons/filter-full.svg';
import dropdownIcon from '../../../assets/icons/dropdown-arrow.svg';
import MetamodelStore from '../../resources/data/MetamodelStore';

const FilterDropDown = ({ getTargets, data }) =>
{
    const [isOpen, setIsOpen] = useState(false);
    const [filterText, setFilterText] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(true);

    useEffect(() =>
    {
        // Initialize all items as selected
        const initialSelectedItems = Object.entries(data).map(([key, value]) => ({
            name: key,
            groupId: value.id_group
        }));
        setSelectedItems(initialSelectedItems);
        setIsSelectAll(true);
    }, [data]);

    useEffect(() =>
    {
        if (isSelectAll)
        {
            getTargets([])
        } else
        {
            getTargets(selectedItems)
        }
    }, [selectedItems, isSelectAll])

    useEffect(() =>
    {
        // Check if all items are selected
        const allSelected = Object.entries(data).length === selectedItems.length;
        setIsSelectAll(allSelected);
    }, [selectedItems, data]);

    const toggleDropdown = () =>
    {
        setIsOpen(prevState => !prevState);
    };

    const handleFilterTextChange = (e) =>
    {
        setFilterText(e.target.value);
    };

    const handleItemChange = (name, groupId, isChecked) =>
    {
        setSelectedItems(prevItems =>
        {
            if (isChecked)
            {
                return [...prevItems, { name, groupId }];
            } else
            {
                return prevItems.filter(item => item.groupId !== groupId);
            }
        });
    };

    const handleSelectAllChange = (isChecked) =>
    {
        if (isChecked)
        {
            const allItems = Object.entries(data).map(([key, value]) => ({
                name: key,
                groupId: value.id_group
            }));
            setSelectedItems(allItems);
        } else
        {
            setSelectedItems([]);
        }
        setIsSelectAll(isChecked);
    };

    const renderDropdownItems = () =>
    {
        const processGroupIDs = Object.entries(data).map(([key, value]) => ({
            name: key,
            groupId: value.id_group
        }));

        return processGroupIDs
            .filter(({ name }) => name.toLowerCase().includes(filterText.toLowerCase()))
            .map(({ name, groupId }) =>
            {
                const sIcon = MetamodelStore.getInstance().getIcon(groupId);
                const isChecked = selectedItems.some(item => item.groupId === groupId);
                return (
                    <label key={name} className="dropdown-item">
                        <input
                            type='checkbox'
                            checked={isChecked}
                            onChange={(e) => handleItemChange(name, groupId, e.target.checked)}
                        />
                        {sIcon && <img src={`data:image/png;base64,${sIcon}`} alt={`${name} Icon`} />}
                        {name}
                    </label>
                );
            });
    };

    return (
        <div className="dropdown">
            <button className="btn btn--filter" onClick={toggleDropdown}>
                <div className="filter--icon">
                    {isSelectAll ? <img src={filterIconEmpty} alt="Filter Icon" /> : <img src={filterIconFull} alt="Filter Icon" />}
                </div>
                <div
                    className={`filter--dropDown ${isOpen ? 'filter--dropDown--active' : ''}`}
                    style={{
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    }}
                >
                    <img src={dropdownIcon} alt="Dropdown Icon" />
                </div>
            </button>
            {isOpen && (
                <div className="dropdown-menu">
                    <input
                        className='input input--filter'
                        type='text'
                        placeholder="Filter items..."
                        value={filterText}
                        onChange={handleFilterTextChange}
                    />
                    <label className="dropdown-item">
                        <input
                            type='checkbox'
                            checked={isSelectAll}
                            onChange={(e) => handleSelectAllChange(e.target.checked)}
                        />
                        Select All
                    </label>
                    {renderDropdownItems()}
                </div>
            )}
        </div>
    );
};

export default FilterDropDown;
